export default "__VITE_ASSET__DbkEuwzv__"